import { apiEndpoint } from "../../constants/constants";
import axios from "axios";
import { Col, Row, message, Pagination, Divider, Typography } from "antd";
import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import ProductCard from "../../components/product/ProductCard";
import { useUser } from "../../contexts/UserContext";
import BrowseProductSearch from "../../components/product/BrowseProductSearch";

const { Text } = Typography;

const BrowseProducts = () => {
  const { currentUser } = useUser();
  const [products, setProducts] = useState([]);
  const [searchParams, setSearchParams] = useState({
    name: "",
    category: "",
    sortCriteria: "averageRatingdesc",
  });
  const [currentPage, setCurrentPage] = useState(1);
  const [totalItems, setTotalItems] = useState(0);
  const pageSize = 20;

  useEffect(() => {
    const fetchProducts = async () => {
      if (!currentUser?._id) return;
      try {
        const response = await axios.get(
          `${apiEndpoint}/product/buy/${currentUser._id}`,
          {
            params: {
              ...searchParams,
              page: currentPage,
              limit: pageSize,
            },
          },
        );
        setProducts(response.data.products);
        setTotalItems(response.data.total);
      } catch (error) {
        message.error("Failed to retrieve products. Please try again.");
        message.error("Failed to retrieve products", error);
      }
    };

    fetchProducts();
  }, [currentUser, searchParams, currentPage, pageSize]);

  const handlePageChange = (page) => {
    setCurrentPage(page);
    window.scrollTo({
      top: 0,
      behavior: "smooth", // Use "auto" for an instant jump
    });
  };

  const totalPages = Math.ceil(totalItems / pageSize);

  return (
    <>
      <div style={{ padding: "20px" }}></div>
      <BrowseProductSearch
        searchParams={searchParams}
        setSearchParams={setSearchParams}
        setCurrentPage={setCurrentPage}
      />
      <Divider />
      <Row gutter={[16, 16]}>
        {products.map((product) => (
          <Col xs={24} sm={12} md={8} lg={6} key={product._id}>
            <Link to={`/buy/product/${product._id}`}>
              <ProductCard product={product} />
            </Link>
          </Col>
        ))}
      </Row>
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          gap: "8px",
          marginTop: "32px",
        }}
      >
        <Pagination
          current={currentPage}
          total={totalItems}
          pageSize={pageSize}
          onChange={handlePageChange}
        />
        {totalItems > 0 && (
          <Text type="secondary" style={{ fontSize: "14px" }}>
            Page {currentPage} of {totalPages}
          </Text>
        )}
      </div>
    </>
  );
};

export default BrowseProducts;
